
import { Component, BaseMixins, Prop } from "@/lib";

@Component({name:"loading"})
export default class Loading extends BaseMixins{
    @Prop({type: Boolean, default:false}) loading:boolean;
}
